/* put helper functions here and export them */

const localeDefault = 'uk'

const updateLocaleLink = function(urlNew) {
    $('[data-locale-link]').each((index, element) => {
        let $link = $(element),
            linkLocale = $link.data('locale-link'),
            hrefNew = linkLocale === localeDefault ?
             urlNew                         // define href from urlNew as passed
              : '/' + linkLocale + urlNew;  // create new relative link with locale
        $link.attr('href', hrefNew);
    });
}

export { updateLocaleLink };